import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSnackbar } from 'notistack';
import { getServerRevision } from '../operations/AboutOperations';

const getClientRevision = (resultHandler) => {
  const version = process.env.REACT_APP_VERSION;
  const buildDate = process.env.REACT_APP_BUILD_DATE;
  resultHandler(version, buildDate);
};

function DialogAbout({ open, onClose }) {
  const [clientVersion, setClientVersion] = useState("");
  const [clientBuildDate, setClientBuildDate] = useState("");
  const [serverVersion, setServerVersion] = useState("");
  const [serverBuildDate, setServerBuildDate] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const close = () => {
    onClose();
  };

  useEffect(() => {
    if (open === true) {
      getServerRevision(enqueueSnackbar, (result) => {
        setServerVersion(result.version);
        setServerBuildDate(result.buildDate);
      });
      getClientRevision((version, buildDate) => {
        setClientVersion(version);
        setClientBuildDate(buildDate);
      });
    }
  }, [enqueueSnackbar, open]);

  return (
    <Dialog open={open} onClose={close} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">About EVA App</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Client Version: {clientVersion}<br />
          Client Build Date: {clientBuildDate}<br /><br />
          Server Version: {serverVersion}<br />
          Server Build Date: {serverBuildDate}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogAbout;